import * as type from 'store/actions/types';

var initialState = {
  isOpen: false,
  activeTopic: null,
};

var helpPane = function (state, action) {
  if (state === undefined) state = initialState;

  switch (action.type) {
    case type.UPDATE_HELP_PANE_STATE: {
      var newState = Object.assign({}, state);
      if (action.payload.isOpen !== undefined) {
        newState.isOpen = action.payload.isOpen;
      }
      if (action.payload.activeTopic !== undefined) {
        newState.activeTopic = action.payload.activeTopic;
      }
      return newState;
    }

    case type.CLEAR_SLATE_VIEWS: {
      return Object.assign({}, initialState);
    }

    default:
      return state;
  }
};

export default helpPane;
